import { TableCell, TableRow } from '../../../../base/table';

interface TableSkeletonProps {
  columns: number;
  rowCount: number;
}

export const TableSkeleton = ({ columns, rowCount }: TableSkeletonProps) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`} className='animate-pulse'>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`} className='py-4'>
              <div className='h-4 w-3/4 rounded-md bg-muted' />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
